import { rem } from '@app/theme/materialUITheme'
import { FormattedMessage } from 'react-intl'
import RegisterToTourButton from '../ui/RegisterToTourButton'

interface Props {
  btnText?: React.ReactNode
  color?: 'primary' | 'secondary'
  disabled?: boolean
  secondaryBtnText?: React.ReactNode
}

const SignUpOrCancelButton = ({ btnText, color = 'primary', disabled, secondaryBtnText }: Props) => {
  return (
    <RegisterToTourButton
      color={color}
      btnText={btnText}
      secondaryBtnText={
        color === 'secondary' ? <FormattedMessage id={'signUp.editOrCancelRegistration'} /> : secondaryBtnText
      }
      style={{ padding: `${rem(8)} ${rem(16)}`, width: rem(280) }}
      disabled={disabled}
    />
  )
}

export default SignUpOrCancelButton
